(() => {
  const updatePanel = (root = document) => {
    root.querySelectorAll('[data-arb-condition-panel]').forEach((panel) => {
      const productInfo = panel.closest('product-info') || document;
      const conditionFieldset = Array.from(productInfo.querySelectorAll('fieldset.product-form__input')).find((fieldset) => {
        const legend = fieldset.querySelector('legend');
        const legendText = legend?.textContent.trim().toLowerCase();
        return legendText === 'condition' || legendText === 'choose fresh or frozen';
      });

      if (!conditionFieldset) {
        panel.dataset.condition = 'generic';
        return;
      }

      const checked = conditionFieldset.querySelector('input[type="radio"]:checked');
      const select = Array.from(productInfo.querySelectorAll('select[name^="options["]')).find((field) =>
        field.name.replace(/^options\[(.*)\]$/, '$1').trim().toLowerCase() === 'condition'
      );
      const value = (checked?.value || select?.value || '').trim().toLowerCase();
      panel.dataset.condition = value === 'frozen' ? 'frozen' : value === 'fresh' ? 'fresh' : 'generic';
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"], select')) updatePanel();
  });

  document.addEventListener('product-info:loaded', (event) => updatePanel(event.target));
  document.addEventListener('DOMContentLoaded', () => updatePanel());
})();
